import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function OutcomesSection() {
  const outcomes = ['Earlier issue resolution — typically 60-70% faster than formal processes', 'Safer, more trusted reporting pathways', 'Stronger leadership confidence in handling complexity', 'Better cultural visibility for executives', 'Reduced escalation risk and legal exposure', 'Average engagement satisfaction: 9.2/10'];
  return <section className="py-24 bg-gradient-to-br from-brand-deep-purple to-brand-charcoal text-white relative overflow-hidden" data-id="element-361">
      {/* Large Arc Motif Background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-5 pointer-events-none" data-id="element-362">
        <svg viewBox="0 0 400 400" fill="none" className="w-full h-full" data-id="element-363">
          <defs data-id="element-364">
            <linearGradient id="outcomeGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-365">
              <stop offset="0%" stopColor="var(--colour-teal)" data-id="element-366" />
              <stop offset="50%" stopColor="var(--colour-magenta)" data-id="element-367" />
              <stop offset="100%" stopColor="var(--colour-orange)" data-id="element-368" />
            </linearGradient>
          </defs>
          <circle cx="200" cy="200" r="180" stroke="url(#outcomeGrad)" strokeWidth="40" strokeDasharray="10 20" data-id="element-369" />
          <circle cx="200" cy="200" r="120" stroke="url(#outcomeGrad)" strokeWidth="30" opacity="0.6" data-id="element-370" />
          <circle cx="200" cy="200" r="60" fill="url(#outcomeGrad)" opacity="0.3" data-id="element-371" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-372">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-373">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-6 leading-tight" data-id="element-374">
            The outcome is not just fewer complaints. It is a healthier system.
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-375">
          {outcomes.map((outcome, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-sm border border-white/20 flex items-start gap-4 hover:bg-white/15 transition-all group" data-id="element-376">
              <div className="w-8 h-8 rounded-full bg-brand-teal/20 flex items-center justify-center shrink-0 group-hover:bg-brand-teal/30 transition-colors" data-id="element-377">
                <Check size={16} className="text-brand-lime" data-id="element-378" />
              </div>
              <span className="text-white/90 font-medium text-[15px] leading-relaxed" data-id="element-379">
                {outcome}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center max-w-3xl mx-auto" data-id="element-380">
          <p className="text-xl md:text-2xl text-white/90 leading-relaxed font-medium italic" data-id="element-381">
            "The organisations that thrive aren't the ones without conflict.
            They're the ones that handle it well."
          </p>
        </motion.div>
      </div>
    </section>;
}